// Family-aware syndrome criteria as data (no logic) so clinical staff can tune
// thresholds via PR without touching detection code. Disease matching is by
// name (case-insensitive) against the family's tracked diseases.

export const SYNDROME_CRITERIA = [
  {
    id: 'syndrome.hboc',
    label: 'Hereditary breast & ovarian cancer',
    omim: '604370',
    diseasePatterns: [/breast cancer/i, /ovarian cancer/i],
    genes: ['BRCA1', 'BRCA2'],
    guideline: { name: 'NCCN HBOC', version: '2024', criteriaId: null },
    minAffectedForStrong: 2
  },
  {
    id: 'syndrome.lynch',
    label: 'Lynch syndrome',
    omim: '120435',
    diseasePatterns: [/colorectal|colon cancer/i, /endometrial cancer/i],
    genes: ['MLH1', 'MSH2', 'MSH6', 'PMS2', 'EPCAM'],
    guideline: {
      name: 'Amsterdam II / Bethesda',
      version: '—',
      criteriaId: null
    },
    minAffectedForStrong: 2
  }
];
